/* ======================================================
   AFINA Shower Filter PDP — gallery, color × pack matrix,
   subscribe/one-time plan (two products), qty, add-to-cart
   (cart-drawer aware). Used by afina-pdp-filter.
   ====================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.afina-fpdp');
  if (!root) return;
  var DATA = {};
  try { DATA = JSON.parse(root.querySelector('[data-afina-fdata]').textContent); } catch (e) { DATA = { variants: [] }; }
  var VARIANTS = DATA.variants || [];
  var MONEY = DATA.moneyFormat || '${{amount}}';

  /* Mirrors Liquid's `money_without_trailing_zeros` for the ACTIVE MARKET's format.
     Each money_format token implies its own separators — NL/DE use
     "€{{amount_with_comma_separator}}" (1.234,56), so substituting one dot-formatted
     string into every token renders the wrong decimal mark outside the US. */
  function money(cents) {
    cents = parseInt(cents, 10) || 0;
    var neg = cents < 0; if (neg) cents = -cents;
    function group(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function fmt(withDecimals, thousands, decimal) {
      if (!withDecimals) return group(String(Math.round(cents / 100)), thousands);
      if (cents % 100 === 0) return group(String(cents / 100), thousands);   /* no trailing zeros */
      var p = (cents / 100).toFixed(2).split('.');
      return group(p[0], thousands) + decimal + p[1];
    }
    var out = MONEY
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, fmt(false, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, fmt(false, ' ', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,            fmt(true,  '.', ','))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g,            fmt(true,  ' ', ','))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,       fmt(true,  "'", '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,                     fmt(false, ',', '.'))
      .replace(/\{\{\s*amount\s*\}\}/g,                                 fmt(true,  ',', '.'));
    return neg ? '-' + out : out;
  }

  var $ = function (s) { return root.querySelector(s); };
  /* Localized button strings: data-afina-cta / -soldout / -adding on [data-afina-fadd]
     (rendered from locale keys), then an optional [data-afina-strings] JSON in root,
     then English. */
  var STR = {};
  try { var strEl = root.querySelector('[data-afina-strings]'); if (strEl) STR = JSON.parse(strEl.textContent) || {}; } catch (e) { STR = {}; }
  function str(attr, key, fallback) { var b = root.querySelector('[data-afina-fadd]'); return (b && b.getAttribute(attr)) || STR[key] || fallback; }
  function entryFor(color, pack) { return VARIANTS.filter(function (v) { return v.color === color && v.pack === pack; })[0]; }
  function activeOf(e) { if (!e) return null; return state.plan === 'sub' ? e.sub : e.once; }

  var vidEl0 = $('[data-afina-fvid]');
  var initId = vidEl0 ? parseInt(vidEl0.value, 10) : null;
  var first = (initId && VARIANTS.filter(function (v) { return v.sub && v.sub.id === initId; })[0])
    || VARIANTS.filter(function (v) { return v.sub && v.sub.available; })[0] || VARIANTS[0] || {};
  var state = { color: first.color, pack: first.pack, plan: (first.sub && first.sub.plan) ? 'sub' : 'once', qty: 1 };
  /* Percentage promo (data-afina-discount-pct on the ATC form): display-only, SUBSCRIPTION only.
     The coupon itself still applies to the whole cart on add-to-cart either way.
     Floor matches Liquid's integer `times/divided_by` so server and client agree. */
  var fForm0 = $('[data-afina-fatc]');
  var discPct = fForm0 ? (parseFloat(fForm0.getAttribute('data-afina-discount-pct') || '0') || 0) : 0;
  function sale(cents) { var c = parseInt(cents, 10) || 0;
    /* Round UP to the next whole dollar, matching Liquid's
       `times: keep | divided_by: 10000.0 | ceil | times: 100`. */
    return discPct > 0 ? Math.ceil(c * (100 - discPct) / 10000) * 100 : c; }

  function render() {
    var e = entryFor(state.color, state.pack) || {};
    var act = activeOf(e) || {};
    var vid = $('[data-afina-fvid]'); if (vid) vid.value = act.id || '';
    var sp = $('[data-afina-fsp]');
    if (sp) { if (state.plan === 'sub' && e.sub && e.sub.plan) { sp.value = e.sub.plan; sp.disabled = false; } else { sp.value = ''; sp.disabled = true; } }
    var cn = $('[data-afina-fcolor-name]'); if (cn) cn.textContent = state.color;
    var q = $('[data-afina-fqty]'); if (q) q.textContent = state.qty;
    var qi = $('[data-afina-fqty-input]'); if (qi) qi.value = state.qty;
    // pack prices reflect the selected color + plan
    root.querySelectorAll('[data-afina-fpack-price]').forEach(function (el) {
      var pk = el.getAttribute('data-afina-fpack-price'); var pe = entryFor(state.color, pk); var pa = pe ? activeOf(pe) : null;
      if (pa) el.innerHTML = money(state.plan === 'sub' ? sale(pa.price) : pa.price);
    });
    /* Struck price: pre-sale price while subscribing (the sale applies), else the
       original compare-at. One-time prices are never discounted for display. */
    root.querySelectorAll('[data-afina-fpack-was]').forEach(function (el) {
      var pk = el.getAttribute('data-afina-fpack-was'); var pe = entryFor(state.color, pk); var pa = pe ? activeOf(pe) : null;
      if (!pa) { el.hidden = true; return; }
      if (state.plan === 'sub' && discPct > 0) { el.innerHTML = money(pa.price); el.hidden = false; }
      else if (pa.compare && pa.compare > pa.price) { el.innerHTML = money(pa.compare); el.hidden = false; }
      else { el.hidden = true; }
    });
    /* Sale flag is subscription-only merchandising, even though the discount covers both plans. */
    root.querySelectorAll('[data-afina-fsaleflag]').forEach(function (el) { el.hidden = state.plan !== 'sub'; });
    var add = $('[data-afina-fadd]'), lbl = $('[data-afina-fadd-label]');
    var avail = !!act.available;
    if (add) add.disabled = !avail;
    if (lbl) lbl.textContent = avail ? str('data-afina-cta', 'add_to_cart', 'Add to Cart') : str('data-afina-soldout', 'sold_out', 'Sold out');
    root.querySelectorAll('[data-afina-fswatch]').forEach(function (b) { var on = b.getAttribute('data-afina-fswatch') === state.color; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    root.querySelectorAll('[data-afina-fpack]').forEach(function (b) { var on = b.getAttribute('data-afina-fpack') === state.pack; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    root.querySelectorAll('[data-afina-fplan]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-afina-fplan') === state.plan); });
  }

  root.querySelectorAll('[data-afina-fswatch]').forEach(function (b) {
    b.addEventListener('click', function () { state.color = b.getAttribute('data-afina-fswatch'); render(); });
  });
  root.querySelectorAll('[data-afina-fpack]').forEach(function (b) {
    b.addEventListener('click', function () { state.pack = b.getAttribute('data-afina-fpack'); render(); });
  });
  root.querySelectorAll('[data-afina-fplan]').forEach(function (b) {
    b.addEventListener('click', function () { state.plan = b.getAttribute('data-afina-fplan'); render(); });
  });
  var qm = $('[data-afina-fqminus]'), qp = $('[data-afina-fqplus]');
  if (qm) qm.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); render(); });
  if (qp) qp.addEventListener('click', function () { state.qty += 1; render(); });

  /* Accordions handled globally by afina-home.js ([data-afina-acc]). */

  (function () {
    var slides = root.querySelectorAll('[data-afina-slide]'); if (!slides.length) return;
    var dots = root.querySelectorAll('[data-afina-dot]'), thumbs = root.querySelectorAll('[data-afina-thumb]'), idx = 0;
    function show(n) { idx = (n + slides.length) % slides.length; slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); }); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); }); thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); }); }
    var p = $('[data-afina-gprev]'), n = $('[data-afina-gnext]');
    if (p) p.addEventListener('click', function () { show(idx - 1); });
    if (n) n.addEventListener('click', function () { show(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
  })();

  var form = $('[data-afina-fatc]');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var en = entryFor(state.color, state.pack) || {}; var act = activeOf(en) || {};
    if (!act.id || !act.available) return;
    var item = { id: act.id, quantity: state.qty };
    if (state.plan === 'sub' && en.sub && en.sub.plan) item.selling_plan = en.sub.plan;
    var add = $('[data-afina-fadd]'), lbl = $('[data-afina-fadd-label]'), orig = lbl ? lbl.textContent : '';
    if (add) add.disabled = true; if (lbl) lbl.textContent = str('data-afina-adding', 'adding', 'Adding…');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (resp) {
        function paint(r) {
          var drawer = document.querySelector('cart-drawer'), opened = false;
          if (drawer) { try { drawer.classList.remove('is-empty'); if (r.sections && drawer.renderContents) { drawer.renderContents(r); opened = true; } if (drawer.open) { drawer.open(); opened = true; } } catch (x) { opened = false; } }
          if (r.sections && r.sections['cart-icon-bubble']) { var b = document.getElementById('cart-icon-bubble'); if (b) b.innerHTML = r.sections['cart-icon-bubble']; }
          if (add) add.disabled = false; if (lbl) lbl.textContent = orig;
          if (!opened) window.location.href = '/cart';
        }
        /* Optional auto-apply discount code (data-afina-discount): apply it, then re-render
           the drawer so it reflects both the new item and the discount. Mirrors afina-pdp.js. */
        var dc = form.getAttribute('data-afina-discount');
        if (!dc) { paint(resp); return; }
        fetch('/discount/' + encodeURIComponent(dc), { redirect: 'manual' })
          .catch(function () {})
          .then(function () { return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
          .then(function (fresh) { paint(fresh ? { sections: fresh } : resp); })
          .catch(function () { paint(resp); });
      })
      .catch(function () { window.location.href = '/cart'; });
  });

  render();
})();
